interface Props {
  seasonXP: number
  currentTier: number
  nextTierXP: number
  xpToNextTier: number
  themeElement?: string
}

const ELEMENT_COLOR: Record<string, string> = {
  fire:  '#FF4800',
  water: '#00F0FF',
  earth: '#39FF14',
  air:   '#E0E0FF',
  void:  '#BF00FF',
  aether:'#FFD700',
}

export default function SeasonXPBar({ currentTier, xpToNextTier, themeElement = 'fire' }: Props) {
  const color = ELEMENT_COLOR[themeElement] ?? '#FF4800'
  const xpIntoTier = 500 - xpToNextTier
  const pct = Math.min(100, Math.round((xpIntoTier / 500) * 100))
  const isMaxTier = currentTier >= 50

  return (
    <div className="space-y-1.5">
      <div className="flex items-center justify-between">
        <span className="font-display font-bold text-xs text-ab-text-dim uppercase tracking-wider">
          Season XP
        </span>
        <span className="font-display font-bold text-xs" style={{ color }}>
          {isMaxTier ? 'MAX TIER' : `${xpIntoTier} / 500 XP`}
        </span>
      </div>
      <div className="h-2 rounded-full bg-white bg-opacity-10 overflow-hidden relative">
        <div
          className="absolute inset-y-0 left-0 rounded-full transition-all duration-700"
          style={{ width: `${isMaxTier ? 100 : pct}%`, background: `linear-gradient(90deg, ${color}99, ${color})` }}
        />
      </div>
      <div className="flex items-center justify-between">
        <span className="text-body text-xs opacity-50">Tier {currentTier}</span>
        {!isMaxTier && (
          <span className="text-body text-xs opacity-50">Tier {currentTier + 1} in {xpToNextTier} XP</span>
        )}
      </div>
    </div>
  )
}
